import { Injectable } from '@angular/core';
import { RegionStorageService } from '../../region/region-storage.service';
import { WebApiConfiguration } from './web-api-configuration';

@Injectable({
  providedIn: 'root'
})
export class WebApiConfigurationService {

  configurations: WebApiConfiguration[] = [];

  constructor(private regionStorageService: RegionStorageService) { }

  loadConfigurations(configurations) {
    for (const configuration of configurations) {
      this.configurations.push(configuration);
    }
  }

  getDefaultConfiguration() {
    return this.configurations.find(c => c.default);
  }

  getLocalConfiguration() {
    const configurationInRegion = this.configurations
      .filter((c) => {
        return c.regions;
      })
      .find((c) => {
        return c.regions.find((r) => {
          return r === this.loadRegion();
        });
      });

    if (configurationInRegion) {
      return configurationInRegion;
    } else {
      return this.getDefaultConfiguration();
    }
  }

  loadRegion() {
    return this.regionStorageService.loadRegion();
  }
}
